<template>
  <ColorCard :dataset="projectInfo" :disabled="disabled" class="project-item" @change="colorChange" :defaultText="projectInfo.title">
    <template>
      <div class="btn-box">
        <div class="task-msgcount-super" v-show="projectInfo.msgcount > 0">{{projectInfo.msgcount > 100 ? '99+' : projectInfo.msgcount}}</div>
        <div class="title-box">
          <div  class="group-drag-box-icon task-drag-box-icon" v-if="!readonly && !disabled">
            <i class="icon iconfont iconicon_drag_order tableIconHover drag-icon"></i>
          </div>
          <ToolTip maxWidth="180px" :title="projectInfo.title">{{ projectInfo.title }}</ToolTip>
        </div>
        <i
          class="icon iconfont iconicon_following star-icon-con tableIconHover"
          :class="star ? 'star-icon' : 'no-star-icon'"
           v-if="!readonly"
          @click.stop="hanldeStar"
        ></i>
      </div>
      <div class="boss-in" v-if="projectInfo.join_project_permission" @click.stop>
        <wf-button type="text" plain @click="toProject">以项目管理员的身份加入</wf-button>
      </div>
    </template>
  </ColorCard>
</template>

<script>
import ToolTip from '@/components/toolTip'
//api
import api from '@/services/api/home/home'
import ColorCard from '@/components/colorControl/card'
import projectApi from '@/services/api/project/project'
import apiSetting from '@/services/api/projectSetting/projectSetting'
export default {
  name: "ProjctItem",
  components: {
    ToolTip,
    ColorCard
  },
  props: {
    projectInfo: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 该项目是否有标星
    star() {
      return this.projectInfo.project_mark_star ? this.projectInfo.project_mark_star.is_mark ? true : false : false
    },
    members() {
      return this.projectInfo.project_members
    }
  },
  data() {
    return {
      editVisible: false
    }
  },
  methods: {
    handleCommand(msg) {
      if (msg === 'edit') {
        this.editVisible = true
      }
    },
    close() {
      this.editVisible = false
    },
    showAllMember(event) {
      this.$router.push({
        path: "/projectMember",
        query: {
          projectId: this.projectInfo.project_id,
          projectName: this.projectInfo.title
        }
      });
      event.stopPropagation();
    },
    // 标星或者取消
    async hanldeStar() {
      const param = {
        project_id: this.projectInfo.project_id,
        is_mark: this.star ? 0 : 1 //已标星就需要取消标星，未标星即需要标星
      }
      const res = await api.markStarToTheProject(param)
      if (res) {
        const _msg = this.star ? '取消标记星标成功' : '标记星标成功'
        this.$message({
          message: _msg,
          type: 'success'
        })
        this.$emit('starSuccess')
      }
    },
    async colorChange(val) {
      let {project_id, background_color,background_text} = val
      let params = {
        project_id,
        background_color,
        background_text
      }
      await projectApi.updateProjectBackground(params)
      this.projectInfo.background_color = background_color
      this.projectInfo.background_text = background_text
    },
    async toProject() {
      await this.$wfAlert('', '进入项目将成为项目管理员，接收此项目信息，确认加入吗？', '', '确定')
      await apiSetting.addProjectMember({ project_id: this.projectInfo.project_id })
      this.$message.success(`成功以管理员身份加入项目【${this.projectInfo.title}】`)
      this.$router.push({
        path: "/task",
        query: {
          projectId: this.projectInfo.project_id,
          isTabShow: true
        }
      })
    }
  }
}
</script>

<style lang="scss">
.project-item {
  &:hover {
    .btn-box .no-star-icon {
      visibility: visible;
    }
    .title-box .group-drag-box-icon {
      display: block;
    }
    .boss-in {
      display: flex;
    }
  }
  .boss-in {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.60);
    display: none;
    align-items: center;
    justify-content: center;
  }
  .btn-box {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    .no-star-icon {
      visibility: hidden;
    }
  }
  .title-box {
    display: flex;
    align-items: center;
    i {
      font-size: 14px;
    }
    .group-drag-box-icon {
      margin-right: 8px;
      display: none;
    }
  }
  .star-icon {
    color: rgba(255, 190, 35, 0.8);
  }
  .no-star-icon {
    color: rgba(32,32,32,0.4);
  }
}
</style>
